import axios from 'axios';
import { familySearchAction } from './FamilySearchSlice';

const familySearch = (token, identifier) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/family/search?identifier=${encodeURIComponent(identifier)}`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(familySearchAction.familySearchSuccess(result.data));
    } catch (e) {
      dispatch(familySearchAction.familySearchFailure(e.response?.data ?? e.message));
    }
  };
};

export default familySearch;